// TODO: the layout depends on the screen width via media-queries, but it
// should depend on its container's width in order to be embeddable anywhere.

import React from 'react'

import Jersey from 'components/Jersey'

import { withStyles, createStyles, WithStyles, Grid, Theme } from '@material-ui/core'

import { IJersey } from 'protos'

interface Props {
  homeJersey?: IJersey | null
  awayJersey?: IJersey | null
}

const styles = (theme: Theme) => {
  const jerseySize = 120
  const breakpointGrowUntil = 564
  const initialVisibleJerseyWidthProportion = 0.45

  const initialJerseyOffset = jerseySize * (1 - initialVisibleJerseyWidthProportion)
  const breakpointGrowFrom = breakpointGrowUntil - 2 * initialJerseyOffset

  return createStyles({
    root: {
      maxWidth: breakpointGrowUntil,
      overflow: 'hidden',
    },
    leftJerseyContainer: {
      marginLeft: -initialJerseyOffset,
      [theme.breakpoints.up(breakpointGrowFrom)]: {
        marginLeft: `calc((${breakpointGrowUntil}px - 100vw) / -2)`,
      },
      [theme.breakpoints.up(breakpointGrowUntil)]: {
        marginLeft: 0,
      },
    },
    rightJerseyContainer: {
      marginRight: -initialJerseyOffset,
      [theme.breakpoints.up(breakpointGrowFrom)]: {
        marginRight: `calc((${breakpointGrowUntil}px - 100vw) / -2)`,
      },
      [theme.breakpoints.up(breakpointGrowUntil)]: {
        marginRight: 0,
      },
    },
  })
}

type InjectedProps = Props & WithStyles<typeof styles>

const ResponsiveJerseyFrame: React.SFC<InjectedProps> = ({
  classes,
  children,
  homeJersey,
  awayJersey,
}) => (
  <Grid container direction="row" className={classes.root}>
    <Grid item className={classes.leftJerseyContainer}>
      <Jersey size="xlarge" jersey={homeJersey || {}} />
    </Grid>
    <Grid item xs>
      {children}
    </Grid>
    <Grid item className={classes.rightJerseyContainer}>
      <Jersey size="xlarge" jersey={awayJersey || {}} />
    </Grid>
  </Grid>
)

export default withStyles(styles)(ResponsiveJerseyFrame)
